<template>


	<div class="min-h-full">
		<nav class="bg-white relative shadow z-20">
			<app-header :auth="$attrs.auth" :fixed-width-header="false"/>
		</nav>

		<Head title="Slide Repository" />

		<div v-if="newCollectionModalOpen">
			<AddNewCollection  @close="handleCollectionModalClose();" :auth="$attrs.auth" :existing="selectedCollection"></AddNewCollection>
		</div>

		<div v-if="addSlideModalOpen">
			<AddNewSlide @close="addSlideModalOpen = false"
						:collections="props.collections" :tags="[]"
			>
			</AddNewSlide>
		</div>


		<main class="relative">

			<div
				class="absolute inset-0"
				style="mask-image:linear-gradient(to bottom, transparent, black 30%);-webkit-mask-image:linear-gradient(to bottom, transparent, black 30%); min-height: calc(100vh - 64px);
				background-image: url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2032%2032%22%20width%3D%2232%22%20height%3D%2232%22%20fill%3D%22none%22%20stroke%3D%22rgb%2815%2023%2042%20%2F%200.04%29%22%3E%3Cpath%20d%3D%22M0%20.5H31.5V32%22%2F%3E%3C%2Fsvg%3E);"
			>
			</div>

			<!-- checkered background lines -->
			<div class="relative z-10 lg:px-8 max-w-7xl mx-auto px-4 py-6 sm:px-6">


				<!-- User not yet setup prompt -->
<!--				<setup-guide-dashboard :auth="$attrs.auth"/>-->



				<!-- Team Collection listing --->
				<div class="border mb-6 p-4 rounded-2xl bg-white">

					<div class="flex justify-between mb-4">
						<div class="">
							<h3 class="">Team Collections</h3>
							<p class="text-xs text-gray-400">Unique sets of slides, typically for each business unit or division in your company.</p>

						</div>
						<div class="flex items-center space-x-3">



<!--							<input autocomplete="off" class="bg-transparent block w-full rounded-full border-0 px-4 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" type="text" name="name" id="url" placeholder="https://docs.google.com/presentation...">-->



<!--							<div class="flex rounded-md shadow-sm">-->
<!--								<div class="relative flex flex-grow items-stretch focus-within:z-10">-->
<!--									<div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">-->
<!--										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-5  text-gray-400">-->
<!--											<path d="M12.232 4.232a2.5 2.5 0 0 1 3.536 3.536l-1.225 1.224a.75.75 0 0 0 1.061 1.06l1.224-1.224a4 4 0 0 0-5.656-5.656l-3 3a4 4 0 0 0 .225 5.865.75.75 0 0 0 .977-1.138 2.5 2.5 0 0 1-.142-3.667l3-3Z" />-->
<!--											<path d="M11.603 7.963a.75.75 0 0 0-.977 1.138 2.5 2.5 0 0 1 .142 3.667l-3 3a2.5 2.5 0 0 1-3.536-3.536l1.225-1.224a.75.75 0 0 0-1.061-1.06l-1.224 1.224a4 4 0 1 0 5.656 5.656l3-3a4 4 0 0 0-.225-5.865Z" />-->
<!--										</svg>-->

<!--									</div>-->
<!--									<input type="url" name="url" id="url" class="block w-72 rounded-none rounded-l-md border-0 py-1.5 pl-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" placeholder="https://docs.google.com/presentation...">-->
<!--								</div>-->
<!--								<button @click="addSlideModalOpen = true"-->
<!--									type="button" class="relative -ml-px inline-flex items-center gap-x-1.5 rounded-r-md px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50">-->
<!--									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5 text-gray-500">-->
<!--										<path d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />-->
<!--									</svg>-->
<!--									<span class="text-gray-700 text-xs">Add Slide</span>-->
<!--								</button>-->
<!--							</div>-->



							<div data-heap="edit-collections" @click="editModeEnabled = !editModeEnabled" class="p-2 rounded-lg bg-white border text-xs flex items-center   cursor-pointer"
							:class="editModeEnabled ? 'border-indigo-600 text-indigo-600 shadow-lg hover:border-indigo-700' : 'text-gray-700 hover:border-gray-400'">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-4 h-4 m-[2px] mr-1" :class="editModeEnabled ? 'text-indigo-600' : 'text-gray-500'">
									<path d="M13.488 2.513a1.75 1.75 0 0 0-2.475 0L6.75 6.774a2.75 2.75 0 0 0-.596.892l-.848 2.047a.75.75 0 0 0 .98.98l2.047-.848a2.75 2.75 0 0 0 .892-.596l4.261-4.262a1.75 1.75 0 0 0 0-2.474Z" />
									<path d="M4.75 3.5c-.69 0-1.25.56-1.25 1.25v6.5c0 .69.56 1.25 1.25 1.25h6.5c.69 0 1.25-.56 1.25-1.25V9A.75.75 0 0 1 14 9v2.25A2.75 2.75 0 0 1 11.25 14h-6.5A2.75 2.75 0 0 1 2 11.25v-6.5A2.75 2.75 0 0 1 4.75 2H7a.75.75 0 0 1 0 1.5H4.75Z" />
								</svg>


								Edit
							</div>
							<div data-heap="new-collection" @click="newCollectionModalOpen = true" class="p-2 rounded-lg bg-white border text-xs flex items-center text-gray-700 hover:border-gray-400 cursor-pointer whitespace-nowrap">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5 text-gray-500">
									<path d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
								</svg>
								New Collection
							</div>
						</div>

					</div>

					<div class="grid grid-cols-2 gap-4 sm:grid-cols-4">
						<div v-for="collection in props.collections" :key="collection.id"
							 class="relative flex items-center rounded-lg border border-gray-300 transition-all hover:bg-gradient-to-tr bg-gradient-to-br from-slate-100  shadow-sm focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:border-gray-400">

							<!-- lock icon for rights -->
							<div v-if="!collection.hasRights" class="absolute bg-white text-gray-900 rounded-full -top-2 -right-2 p-1 border border-gray-300">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-4 h-4">
									<path fill-rule="evenodd" d="M8 1a3.5 3.5 0 0 0-3.5 3.5V7A1.5 1.5 0 0 0 3 8.5v5A1.5 1.5 0 0 0 4.5 15h7a1.5 1.5 0 0 0 1.5-1.5v-5A1.5 1.5 0 0 0 11.5 7V4.5A3.5 3.5 0 0 0 8 1Zm2 6V4.5a2 2 0 1 0-4 0V7h4Z" clip-rule="evenodd" />
								</svg>
							</div>
							<!-- lock icon for rights -->

							<!-- edit icon for rights -->
							<div @click="handleEdit(collection)" v-if="collection.hasEditRights && editModeEnabled" class="-right-2 -top-2 absolute bg-indigo-600 cursor-pointer border border-gray-300 flex p-1 px-3 rounded-full text-white">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-4 h-4 mr-1">
									<path fill-rule="evenodd" d="M11.013 2.513a1.75 1.75 0 0 1 2.475 2.474L6.226 12.25a2.751 2.751 0 0 1-.892.596l-2.047.848a.75.75 0 0 1-.98-.98l.848-2.047a2.75 2.75 0 0 1 .596-.892l7.262-7.261Z" clip-rule="evenodd" />
								</svg>
								<span class="text-xs">Edit</span>
							</div>
							<!-- lock icon for rights -->

							<component :is="collection.hasRights ? Link : 'div'" :href="'repository/' + collection.short_name" class="focus:outline-none flex flex-col justify-between w-full h-full px-6 py-5"
									:class="collection.hasRights ? '' : 'cursor-not-allowed'"
									data-heap="select-collection">
								<div class="min-w-0 flex-1 grow">
<!--									<span class="absolute inset-0" aria-hidden="true" />-->
									<div class="flex justify-between">
										<p class="text-sm font-medium text-gray-900">{{ collection.name }}</p>
										<div class="bg-white border rounded-full px-2 text-gray-400 py-px text-xs flex-none h-full">{{ collection.slides_count }} slides</div>
									</div>
									<p class="pt-1 text-xs text-gray-500">{{ collection.description }}</p>
								</div>


								<div class="flex justify-between items-center mt-4">
									<div class="flex text-xs bg-white border rounded-full px-2 text-gray-400 w-fit items-center h-[22px]">
										<div v-for="option in visibilityOptions" :key="option.slug">
											<div v-if="collection.visibility === option.slug" v-html="option.icon" class=""></div>
										</div>
										<div class="">
											{{ collection.visibility.charAt(0).toUpperCase() + collection.visibility.slice(1) }}
										</div>
									</div>


									<div v-if="collection.visibility === 'public'">
										<div class="flex items-center font-medium text-gray-500 text-xs">
											<img v-if="$attrs.auth.user.current_team?.name !== 'Personal'" :src="'https://www.google.com/s2/favicons?domain=' + $attrs.auth.user.current_team?.domain + '&sz=128'" class="h-4 mr-2">
											<span class="">{{ $attrs.auth.user.current_team?.name }}</span>
										</div>
									</div>
									<div v-else class="isolate flex -space-x-1 overflow-hidden">
										<span v-for="(user,index) in collection.users.slice(0, 5)" :key="user.id">
											<img v-if="user.photoLink" :src="user.photoLink" class="h-6 w-6 rounded-full border ring-2 ring-white">
											<span v-else class="h-6 w-6 border rounded-full bg-gray-200 text-gray-600 flex justify-center items-center ring-2 ring-white text-sm">{{ user?.name.charAt(0).toUpperCase() }}</span>
										</span>
										<span v-if="collection.users.length > 5" class="h-6 w-6 border rounded-full bg-gray-200 text-gray-600 flex justify-center items-center ring-2 ring-white text-xs">+{{ collection.users.length - 5 }}</span>
									</div>

								</div>
							</component>

						</div>

					</div> <!-- end grid -->
				</div>
				<!-- End Team Collection listing --->


				<!-- Two Column --->
				<div class="grid grid-cols-2 gap-4 mb-6">
					<!-- Recent presentations -->
					<div class="border p-4 rounded-2xl bg-white">

						<div class="flex justify-between mb-4">
							<div class="">
								<h3 class="">Recent Presentations</h3>
								<p class="text-xs text-gray-400">Record of your recently generated presentations.</p>

							</div>
							<!--						<div @click="newCollectionModalOpen = true" class="p-2 rounded-lg bg-white border text-xs flex items-center text-gray-700 hover:border-gray-400 cursor-pointer">-->
							<!--							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5 text-gray-500">-->
							<!--								<path d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />-->
							<!--							</svg>-->
							<!--							New Collection-->
							<!--						</div>-->
						</div>


						<div class="border border-2 border-dashed p-12 rounded-lg text-center text-gray-200">
							Coming soon
						</div>


					</div>
					<!-- End Recent presentations -->

					<!-- Quick Start -->
					<div class="border p-4 rounded-2xl bg-white">
						<div class="flex justify-between mb-4">
							<div class="">
								<h3 class="">Quick Start</h3>
								<p class="text-xs text-gray-400">Frameworks to quickly scaffold common presentation types.</p>

							</div>
						</div>

						<div class="border-2 border-dashed p-12 rounded-lg text-center text-gray-200">
							Coming soon
						</div>
					</div>
					<!-- End Quick Start -->
				</div>
				<!-- Two Column --->

				<!-- Three Column -->
				<div class="grid grid-cols-3 gap-4 mb-6">

					<!-- Analytics Start -->
					<div class="border p-4 rounded-2xl bg-white">
						<div class="flex justify-between mb-4">
							<div class="">
								<h3 class="">Repository Analytics</h3>
								<p class="text-xs text-gray-400">Health and usage statistics about your team repository.</p>

							</div>
						</div>

						<div class="border-2 border-dashed p-12 rounded-lg text-center text-gray-200">
							Coming soon
						</div>
					</div>
					<!-- Analytics Start -->

					<!-- Notifications Start -->
					<div class="border p-4 rounded-2xl bg-white">
						<div class="flex justify-between mb-4">
							<div class="">
								<h3 class="">Notifications</h3>
								<p class="text-xs text-gray-400">Relevant activity and actions to maintain repository health.</p>

							</div>
						</div>

						<div class="border-2 border-dashed p-12 rounded-lg text-center text-gray-200">
							Coming soon
						</div>
					</div>
					<!-- Notifications End -->

					<!-- Admin Start -->
					<div class="border p-4 rounded-2xl bg-white">
						<div class="flex justify-between mb-4">
							<div class="">
								<h3 class="">Administration</h3>
								<p class="text-xs text-gray-400">Manage Google Authentication and bookmarklet.</p>

							</div>
						</div>

						<a data-heap="start-google-auth" href="/start-google-auth" class="bg-white border flex justify-between items-center rounded-lg shadow-xl w-full mb-2">
							<div class="flex items-center">
								<div class="m-2 p-2">
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/><path fill="none" d="M1 1h22v22H1z"/></svg>
								</div>
								<div class="pr-6 text-left">
									<div class="text-sm text-gray-700">Google Authentication</div>
									<div class="text-xs text-gray-500">{{ $attrs.auth.user.email }}</div>
									<!--				<div class="text-lg font-googleBold leading-4 text-gray-900">Please Reauthenticate</div>-->
								</div>
							</div>

							<div class="p-1 rounded-full text-xs mr-4 px-4"
								 :class="[$attrs.auth.user.hasGAuth ? ($attrs.auth.user.isGAuthValid ? 'bg-green-200 text-green-500' : 'bg-red-200 text-red-500')  : 'bg-gray-200 text-gray-600']">
								{{ $attrs.auth.user.hasGAuth ? ($attrs.auth.user.isGAuthValid ? 'Valid' : 'Expired') : 'Not Setup'}}
							</div>
						</a>

						<div class="bg-white border flex p-2 justify-between items-center rounded-lg shadow-xl w-full mb-2">
							<div class="flex items-center">
								<div class="px-2 text-left">
									<div class="text-sm text-gray-700">Slide Bookmark</div>
									<div class="text-xs text-gray-500">Drag to bookmark bar, or save link.</div>
								</div>
							</div>
							<a @click.prevent="clickedBookmarklet"  :href="customURL" class="p-2 rounded-lg border text-xs flex hover:border-gray-400 my-px"
							   data-heap="bookmarklet-setup">
<!--								<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">-->
<!--									<path stroke-linecap="round" stroke-linejoin="round" d="M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0Z" />-->
<!--								</svg>-->
								<ApplicationLogo class="size-4"/>
								<span class="pl-2">Save Slide</span>
							</a>
						</div>

					</div>
					<!-- Admin End -->

				</div>

			</div>

		</main>
	</div>

</template>

<script setup>
import { Head, Link } from "@inertiajs/vue3";
import AppHeader from "@/Layouts/AppHeader.vue";
import AddNewCollection from "@/Pages/SlideRepo/Modals/AddNewCollection.vue";
import {ref, useAttrs } from "vue";
import SetupGuideDashboard from "@/Pages/SlideRepo/SetupGuideDashboard.vue";
import AddNewSlide from "@/Pages/SlideRepo/Modals/AddNewSlide.vue";
import ApplicationLogo from "@/Components/ApplicationLogo.vue";

const attrs = useAttrs()


const props = defineProps({
	collections: {type: Object},
});

const visibilityOptions = [
	{slug: 'public', shortName: 'Public', description: 'Anyone on your team can see and join this collection.', icon: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="flex-shrink-0 h-5 w-5 mr-1"><path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"/><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/></svg>'},
	{slug: 'private', shortName: 'Private', description: 'Only added members can view slides, others may request access.', icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-4 h-4 mr-1"><path fill-rule="evenodd" d="M8 1a3.5 3.5 0 0 0-3.5 3.5V7A1.5 1.5 0 0 0 3 8.5v5A1.5 1.5 0 0 0 4.5 15h7a1.5 1.5 0 0 0 1.5-1.5v-5A1.5 1.5 0 0 0 11.5 7V4.5A3.5 3.5 0 0 0 8 1Zm2 6V4.5a2 2 0 1 0-4 0V7h4Z" clip-rule="evenodd" /></svg>'},
	{slug: 'secret', shortName: 'Secret', description: 'Only members manually added can see this collection, it is hidden otherwise. Team admins can see, but still must be added to view slides.', icon: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="flex-shrink-0 h-5 w-5 mr-1"><path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88" /></svg>'},
]
const newCollectionModalOpen = ref(false);

const customURL = "javascript:(function()%7Bvar%20e%20%3D%20%22" + encodeURIComponent(window.location.origin) + "%2Fapi%2Fslide-process%3Fauth%3D" + attrs.auth.user.uuid + "%22%20%2B%20%22%26slide%3D%22%20%2B%20document.location.hash.slice(1)%20%2B%20%22%26url%3D%22%20%2B%20document.location.href%3Bvar%20xhr%20%3D%20new%20XMLHttpRequest()%3Bxhr.onreadystatechange%20%3D%20function()%20%7Bif%20(this.readyState%20%3D%3D%3D%204%20%26%26%20this.responseText.length%20%3E%200)%20%7BNotification.requestPermission((result)%20%3D%3E%20%7Bif%20(result%20%3D%3D%3D%20'denied')%20%7Balert('Enable%20notifications%20for%20passive%20alerts%20when%20you%20save%20a%20slide.')%3B%7D%20else%20%7Bnew%20Notification(this.responseText)%3Bconsole.log(this.response)%3B%7D%7D)%3B%7D%7D%3Bxhr.open(%22POST%22%2C%20encodeURI(e))%3Bxhr.send()%7D)()"

function clickedBookmarklet() {
	alert('Looks like you clicked your "Save Slide Bookmarket" while on SlideCub. Instead, save this as a bookmark to your browser. Then, while you\'re on a Google Slide Presentation, click the bookmark when you want to save a slide to your SlideCub repository.');
}

const editModeEnabled = ref(false);
const selectedCollection = ref();

function handleEdit(collection) {
	if(editModeEnabled) {
		selectedCollection.value = collection;
		newCollectionModalOpen.value = true;
	}
}

function handleCollectionModalClose() {
	newCollectionModalOpen.value = false;
	selectedCollection.value = false;
	editModeEnabled.value = false;
}

const addSlideModalOpen = ref(false);

</script>

<style scoped>

</style>